import React, { useState, useRef, useEffect } from 'react'
import styles from './index.less'
import { ArrowRightOutlined } from '@ant-design/icons';
import classNames from 'classnames';

function index() {
    const [activeIndex, setActiveIndex] = useState(0)
    const [dataArr, setDataArr] = useState([{
        title: '目标检测',
        img: '01.png',
        content: '目标检测定制算法用于识别图片中单个或多个目标主体，包括目标的位置、名称、数量信息等。常见应用场景：视频监控、场景检测、物体计数。',
        dataLi: [
            {
                li_Content: "视频监控",
            },
            {
                li_Content: "工业检测",
            },
            {
                li_Content: "医疗诊断",
            },
            {
                li_Content: "区域安防",
            },
        ]
    }, {
        title: '图像分类',
        img: '02.png',
        content: '用于识别图片中是否为某类物体或状态，适合主体或状态单一的场景。常见应用场景：图片内容检索、视觉检测等。',
        dataLi: [
            {
                li_Content: "动物识别",
            },
            {
                li_Content: "车辆车牌识别",
            },
            {
                li_Content: "商品分类",
            },
            {
                li_Content: "制造业分拣",
            },

        ]
    }, {
        title: 'OCR文本识别',
        img: '03.png',
        content: '定制化训练文字识别算法，结构化输出关键字段内容，满足个性化卡证票据识别需求，适用于证照电子化审批、财务报销电子化等场景',
        dataLi: [
            {
                li_Content: "票据识别",
            },
            {
                li_Content: "证照审批",
            },
            {
                li_Content: "财务报销",
            },
            {
                li_Content: "卡证识别",
            },
        ]
    },
    ])

    return (
        <div className={styles.container} >
            <div className={styles.container_box}>
                <div className={styles.item}>
                    <div className={styles.title}>
                        <span className={styles['title-text']}>多种能力领域</span>
                        <span className={styles['title-right']}></span>
                    </div>
                    <div className={styles.subTitle}>新一代的人工智能开发平台,一站式操作体验</div>
                    <img className={styles.bg_img} src={require('assets/images/home/背景点点-.png')} alt="" />
                </div>
                <div className={styles.itemss}>

                    {
                        dataArr.map((item, index) => (
                            <div className={classNames(styles.item, activeIndex == index && styles.active, 'flag')} onMouseEnter={() => setActiveIndex(index)}>
                                <img src={require('assets/images/home/' + item.img)} alt="" />
                                {<div className={classNames(styles.detail, activeIndex !== index && styles.detail_hidden)}>
                                    <div className={styles.title}>{item.title}</div>
                                    <div className={styles.line}></div>
                                    <div className={styles.content}>
                                        {item.content}
                                    </div>
                                    <div className={styles.li_ALL}>
                                        {
                                            item.dataLi?.map((ii) => (
                                                <div className={styles.details_li}>
                                                    <div className={styles.li_content}>
                                                        {ii.li_Content}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    {/* <div className={styles.test}>
                                    <span className='mr-10'>在线试用</span>
                                    <ArrowRightOutlined />
                                </div> */}
                                </div>}
                                {
                                    // <div className={classNames(styles.simple, activeIndex == index && styles.simple_hidden)}>
                                    //     <div className={styles.title}>{item.title}</div>
                                    // </div>
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default index